import { createContext } from 'react'

import { useQuery } from '@redwoodjs/web'

import { GET_EMPLOYEES_ONLY } from 'src/graphql/employees.graphql'
import { EmployeeStatus } from 'src/graphql/types/employees'

const RecruitersContext = createContext(null)

const RecruitersContextProvider = ({ children }) => {
  const { data: employees, loading: employeesLoading } = useQuery(
    GET_EMPLOYEES_ONLY,
    {
      variables: {
        pageInfo: { offset: 0, limit: 100 },
        filters: { roleTypes: ['RECRUITER'] },
      },
      fetchPolicy: 'cache-and-network',
    }
  )
  const recruiters = employeesLoading
    ? []
    : employees?.employees?.items?.map((employee) => {
        const name = `${employee.firstName} ${employee.lastName}`
        const isInactive = employee.status !== EmployeeStatus.ACTIVE
        return {
          label: isInactive ? `${name} (Inactive)` : name,
          value: employee.employeeId,
        }
      }) ?? []

  return (
    <RecruitersContext.Provider value={recruiters}>
      {children}
    </RecruitersContext.Provider>
  )
}

export { RecruitersContext, RecruitersContextProvider }
